import Logo from "./logo.png";
import Astar from "./astar.png";
import HomeMainPic from "./home-main-pic.png";
import SpaceStar from "./space-stars.svg";
import Tree1 from "./plant/1.png";
import Tree2 from "./plant/2.png";
import Tree3 from "./plant/3.png";
import Tree4 from "./plant/4.png";
import Tree5 from "./plant/5.png";
import Tree6 from "./plant/6.png";
import airlist from "assets/list.json";
import { AirDrop } from "../constants";
import dorahacks from "./partner/dorahacks.svg";
import oneblock from "./partner/oneblock.png";
import substrate from "./partner/substrate.png";
const AIR_DROP_LIST = airlist as unknown as AirDrop[];

export {
  dorahacks,
  oneblock,
  substrate,
  Logo,
  Astar,
  HomeMainPic,
  SpaceStar,
  Tree1,
  Tree2,
  Tree3,
  Tree4,
  Tree5,
  Tree6,
  AIR_DROP_LIST,
};
